import React, { useState, useEffect } from 'react';
import './SessionWarning.css';

interface SessionWarningProps {
  remainingMinutes: number;
  onExtendSession: () => void;
  onLogout: () => void;
  visible: boolean;
}

const SessionWarning: React.FC<SessionWarningProps> = ({
  remainingMinutes,
  onExtendSession,
  onLogout,
  visible
}) => {
  const [timeLeft, setTimeLeft] = useState(remainingMinutes);

  useEffect(() => {
    setTimeLeft(remainingMinutes);
  }, [remainingMinutes]);

  useEffect(() => {
    if (!visible) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          clearInterval(interval);
          return 0;
        }
        return prev - (1/60); // Decrease by 1 second (1/60 minute)
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [visible]);

  if (!visible) return null;

  const minutes = Math.floor(timeLeft);
  const seconds = Math.floor((timeLeft - minutes) * 60);

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-header">
          <h3>Session Timeout Warning</h3>
        </div>

        <div className="session-warning-content">
          <p>Your session will expire due to inactivity in:</p>

          <div className="countdown-timer">
            <span className="time-display">
              {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
          </div>

          <p>Would you like to extend your session?</p>
        </div>

        <div className="session-warning-actions">
          <button
            className="btn btn-primary"
            onClick={onExtendSession}
          >
            Yes, Keep Me Logged In
          </button>

          <button
            className="btn btn-secondary"
            onClick={onLogout}
          >
            Logout Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarning;
